import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'backlog.modals.move-cards-active-sprint-modal.title',
		defaultMessage: 'Move issues',
		description: '',
	},
	changedScope: {
		id: 'backlog.modals.move-cards-active-sprint-modal.changed-scope',
		defaultMessage: 'Sprint scope will be affected by this action.',
		description: '',
	},
	movedOneCard: {
		id: 'backlog.modals.move-cards-active-sprint-modal.moved-one-card',

		defaultMessage:
			'{cardName} will be moved from sprint {originCardListName} to sprint {destinationCardListName}.',

		description: '',
	},
	movedTwoCards: {
		id: 'backlog.modals.move-cards-active-sprint-modal.moved-two-cards',

		defaultMessage:
			'{cardName} and {anotherCardName} will be moved from sprint {originCardListName} to sprint {destinationCardListName}.',

		description: '',
	},
	movedMoreCards: {
		id: 'backlog.modals.move-cards-active-sprint-modal.moved-more-cards',

		defaultMessage:
			'{cardName}, {anotherCardName} and {moreCardsCountText} more {moreCardsCount, plural, one {issue} other {issues}} will be moved from sprint {originCardListName} to sprint {destinationCardListName}.',

		description: '',
	},
	confirm: {
		id: 'backlog.modals.move-cards-active-sprint-modal.confirm',
		defaultMessage: 'Confirm',
		description: '',
	},
	cancel: {
		id: 'backlog.modals.move-cards-active-sprint-modal.cancel',
		defaultMessage: 'Cancel',
		description: '',
	},
	titleIssueTermRefresh: {
		id: 'backlog.modals.move-cards-active-sprint-modal.title-issue-term-refresh',
		defaultMessage: 'Move issues',
		description: '',
	},
	movedMoreCardsIssueTermRefresh: {
		id: 'backlog.modals.move-cards-active-sprint-modal.moved-more-cards-issue-term-refresh',
		defaultMessage:
			'{cardName}, {anotherCardName} and {moreCardsCountText} more {moreCardsCount, plural, one {issue} other {issues}} will be moved from sprint {originCardListName} to sprint {destinationCardListName}.',
		description: '',
	},
});
